import { post, get, del } from '../xhr/fetch'
import { OPERATION_CENTER_PREFIX } from '../config'

// 内容列表
export const GET_CONTENT_LIST = (data) => {
  return post(`${OPERATION_CENTER_PREFIX}/app/v1/page`, data)
}

// 新增内容名称
export const ADD_CONTENT_NAME = (data) => {
  return post(`${OPERATION_CENTER_PREFIX}/app/v1/saveAppName`, data)
}

// 获取内容详情
export const GET_CONTENT_DETAIL = (id) => {
  return get(`${OPERATION_CENTER_PREFIX}/app/v1/${id}`)
}

// 删除内容
export const DEL_CONTENT = (data) => {
  return del(`${OPERATION_CENTER_PREFIX}/app/v1`, data)
}

// 更新内容信息
export const UPDATE_CONTENT_INFO = (data) => {
  return post(`${OPERATION_CENTER_PREFIX}/app/v1/updatePkg`, data)
}
